// extracted by mini-css-extract-plugin
module.exports = {"err":"articleHeader_err__2Pvmk","ok":"articleHeader_ok__2YaoF"};